// Recovered compiled webpack factory 33018. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { WallOfLove: () => f });
  var n = r(95155),
    a = r(12115),
    s = r(65025),
    i = r(86048),
    l = r(57562),
    o = r(87254),
    c = r(52273),
    d = r.n(c);
  let u = [
    {
      name: "Rob",
      handle: "robsicat",
      body: "@ultramock is a cheat code for making your product look 10x better",
      date: "Aug 5",
      verified: !0,
      avatar: "/testimonials/robsicat.jpg",
      url: "https://x.com/robsicat/status/2085121763034411020",
    },
    {
      name: "Delfina",
      handle: "pixelsbyDelfina",
      body: "amazing product and beautiful ui design! can't believe I just found this tool",
      date: "Aug 17",
      verified: !0,
      avatar: "/testimonials/pixelsbydelfina.jpg",
      url: "https://x.com/pixelsbyDelfina/status/2089377430674825427",
    },
    {
      name: "andrew\uD83C\uDF31",
      handle: "0x__andrew",
      body: 'Someone finally solved the "how do we make marketing collateral for dashboards look sexy" problem. Would have killed to have this a few years ago. Nice work @ultramock \uD83D\uDC4F\uD83C\uDFFC',
      date: "May 1",
      verified: !0,
      avatar: "/testimonials/0x__andrew.jpg",
      url: "https://x.com/0x__andrew/status/2050065430186995749",
    },
    {
      name: "Allan",
      handle: "Allan",
      body: "Damn. Purchased.",
      date: "Aug 15",
      verified: !0,
      avatar: "/testimonials/allan.jpg",
      url: "https://x.com/Allan/status/2088703710415233155",
    },
    {
      name: "Evil Rabbit",
      handle: "evilrabbit_",
      body: "\uD83D\uDD25",
      date: "Apr 30",
      verified: !0,
      avatar: "/testimonials/evilrabbit_.jpg",
      url: "https://x.com/evilrabbit_/status/2049862125171151021",
    },
    {
      name: "Kevin ⨀",
      handle: "kvncnls",
      body: "Just tried it out, this is insane work dude!",
      date: "May 24",
      verified: !0,
      avatar: "/testimonials/kvncnls.jpg",
      url: "https://x.com/kvncnls/status/2058564484319301763",
    },
    {
      name: "Juraj Weszter",
      handle: "jurajwe",
      body: "This is a super useful product – played around with it and you can do much more with it than I expected.",
      date: "May 6",
      verified: !0,
      avatar: "/testimonials/jurajwe.jpg",
      url: "https://x.com/jurajwe/status/2052045774305849533",
    },
    {
      name: "Kyle Anthony Miller",
      handle: "kyleanthony",
      body: "Dang looks hot",
      date: "Apr 30",
      verified: !0,
      avatar: "/testimonials/kyleanthony.jpg",
      url: "https://x.com/kyleanthony/status/2049914317907091872",
    },
    {
      name: "Nick Venturi",
      handle: "nickventuri",
      body: "finally i can stop opening after effects for simple animations",
      date: "Jul 28",
      verified: !0,
      avatar: "/testimonials/nickventuri.jpg",
      url: "https://x.com/nickventuri/status/2082169980762677386",
    },
    {
      name: "Elie Steinbock",
      handle: "elie2222",
      body: "Woah. Love this new product by @joshmillgate \uD83E\uDD2F It creates stylish mocks and animations of your product.",
      date: "Apr 13",
      verified: !0,
      avatar: "/testimonials/elie2222.png",
      url: "https://x.com/elie2222/status/2043735187427672352",
    },
    {
      name: "berzan",
      handle: "berzan",
      body: "oh my god very impressive",
      date: "May 1",
      verified: !0,
      avatar: "/testimonials/berzan.jpg",
      url: "https://x.com/berzan/status/2050136350587035911",
    },
    {
      name: "Vinay Juneja",
      handle: "vinayjunejaa",
      body: "Holy shit, how the hell this was not visible to me, great product man \uD83D\uDD25\uD83D\uDD25",
      date: "Apr 30",
      verified: !0,
      avatar: "/testimonials/vinayjunejaa.jpg",
      url: "https://x.com/vinayjunejaa/status/2049747805414236653",
    },
    {
      name: "Ridd \uD83E\uDD3F",
      handle: "ridd_design",
      body: "you da man",
      date: "Apr 1",
      verified: !0,
      avatar: "/testimonials/ridd_design.png",
      url: "https://x.com/ridd_design/status/2039396193554387183",
    },
    {
      name: "jack",
      handle: "jackbutcher",
      body: "Incredible piece of kit, thank you for building",
      date: "May 29",
      verified: !0,
      avatar: "/testimonials/jackbutcher.png",
      url: "https://x.com/jackbutcher/status/2060493708970111110",
    },
    {
      name: "joshpuckett",
      handle: "joshpuckett",
      body: "nah this crazy \uD83D\uDD25",
      date: "Jul 20",
      verified: !0,
      avatar: "/testimonials/joshpuckett.jpg",
      url: "https://x.com/joshpuckett/status/2079339974336577846",
    },
    {
      name: "Dott",
      handle: "DottChen",
      body: "congrats! this is really good for designer founders",
      date: "May 7",
      verified: !0,
      avatar: "/testimonials/dottchen.jpg",
      url: "https://x.com/DottChen/status/2052196463858589922",
    },
    {
      name: "Aaron Moody",
      handle: "Imaaronmoody",
      body: "Just found @ultramock and it's so good!",
      date: "May 6",
      verified: !0,
      avatar: "/testimonials/imaaronmoody.jpg",
      url: "https://x.com/Imaaronmoody/status/2051955927360684135",
    },
    {
      name: "Gabriel",
      handle: "gabriell_lab",
      body: "Love this product Josh!",
      date: "Apr 30",
      verified: !0,
      avatar: "/testimonials/gabriell_lab.jpg",
      url: "https://x.com/gabriell_lab/status/2049797008186094038",
    },
  ];
  function m(e) {
    let { name: t, avatar: r } = e;
    return (0, n.jsx)("img", {
      src: r,
      alt: t,
      width: 40,
      height: 40,
      loading: "lazy",
      decoding: "async",
      className: "h-10 w-10 shrink-0 rounded-full object-cover",
    });
  }
  function h() {
    return (0, n.jsx)("svg", {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: "h-[15px] w-[15px] shrink-0 text-[#1d9bf0]",
      children: (0, n.jsx)("path", {
        fill: "currentColor",
        d: "M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34Zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77Z",
      }),
    });
  }
  function p() {
    return (0, n.jsx)("svg", {
      viewBox: "0 0 24 24",
      "aria-hidden": !0,
      className: "h-[18px] w-[18px] shrink-0 text-[#09090b] dark:text-[#fafafa]",
      children: (0, n.jsx)("path", {
        fill: "currentColor",
        d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z",
      }),
    });
  }
  function f() {
    let [e, t] = (0, a.useState)(5);
    return (0, n.jsxs)("section", {
      "data-track-section": "wall_of_love",
      className: o.R1,
      children: [
        (0, n.jsx)(l.Reveal, {
          className: "max-w-[620px]",
          children: (0, n.jsxs)(i.Heading, {
            children: ["Loved by people", (0, n.jsx)("br", {}), "who ship"],
          }),
        }),
        (0, n.jsx)("div", {
          id: "wall-of-love-posts",
          className: "mt-10 gap-5 sm:columns-2 lg:columns-3",
          children: u.map((t, r) =>
            (0, n.jsx)(
              l.Reveal,
              {
                index: r,
                className: `mb-5 break-inside-avoid ${r >= e ? "hidden sm:block" : ""}`,
                children: (0, n.jsxs)("figure", {
                  className:
                    "squircle-lg border border-black/[0.08] bg-white p-5 shadow-[0_1px_2px_rgba(0,0,0,0.03)] dark:border-white/[0.10] dark:bg-[#0d0d0f]",
                  children: [
                    (0, n.jsxs)("div", {
                      className: "flex items-start gap-3",
                      children: [
                        (0, n.jsx)(m, { name: t.name, avatar: t.avatar }),
                        (0, n.jsxs)("div", {
                          className: "min-w-0 flex-1",
                          children: [
                            (0, n.jsxs)("div", {
                              className: "flex items-center gap-1",
                              children: [
                                (0, n.jsx)("span", {
                                  className: `${s.$p} truncate font-semibold text-[#09090b] dark:text-[#fafafa]`,
                                  children: t.name,
                                }),
                                t.verified && (0, n.jsx)(h, {}),
                              ],
                            }),
                            (0, n.jsxs)("span", {
                              className: `${s.$p} block truncate text-[#71717a] dark:text-[#a1a1aa]`,
                              children: ["@", t.handle],
                            }),
                          ],
                        }),
                        (0, n.jsx)("a", {
                          href: t.url ?? `https://x.com/${t.handle}`,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          "aria-label": `View ${t.name}'s post on X`,
                          className:
                            "shrink-0 text-[#09090b] no-underline opacity-50 transition-opacity hover:opacity-100 dark:text-[#fafafa]",
                          children: (0, n.jsx)(p, {}),
                        }),
                      ],
                    }),
                    (0, n.jsx)("blockquote", {
                      className: `${s.$p} mt-3 text-[#27272a] dark:text-[#d4d4d8]`,
                      children: t.body,
                    }),
                    (0, n.jsxs)("figcaption", {
                      className: `${s.$p} mt-4 text-[#a1a1aa] dark:text-[#71717a]`,
                      children: [t.date, " \xb7 2026"],
                    }),
                  ],
                }),
              },
              t.handle,
            ),
          ),
        }),
        e < u.length &&
          (0, n.jsx)("button", {
            type: "button",
            "aria-controls": "wall-of-love-posts",
            className: `${s.$p} ${d().key} squircle-md mt-3 w-full py-3 font-medium sm:hidden`,
            onClick: () => t((e) => Math.min(e + 5, u.length)),
            children: "Show more",
          }),
      ],
    });
  }
}
